/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import { Select, SelectItem } from "carbon-components-react";
import { LogicalOperator, TaskConfigParamOptions, TaskClause } from "@eave/shared/types/api";
import getHandlers from "web_modules/shared/FormHelpers/eventHandlers";
import TaskConditional from "./TaskConditional";

const styles = require("./styles.module.scss");

interface TaskClauseEditorProps {
  taskOptions: TaskConfigParamOptions;
  formState: TaskClause;
  setFormState: Function;
  typeOfClause: string;

  // Disable Submit button on parent Modal
  setDisableModalSubmit: Function;
}

const removeTaskCondition = (conditions, index) => {
  const conditionsList = [...conditions];
  conditionsList.splice(index, 1);
  return conditionsList;
};

const updateTaskCondition = (conditions, index, updatedCondition) => {
  const conditionsList = [...conditions];
  conditionsList.splice(index, 1, updatedCondition);
  return conditionsList;
};

const TaskClauseEditor: React.FC<TaskClauseEditorProps> = ({
  taskOptions,
  formState,
  setFormState,
  typeOfClause,
  setDisableModalSubmit,
}) => {
  const [invalidFields, setInvalidFields] = useState([]);

  const { handleSelectChange } = getHandlers(
    formState,
    setFormState,
    invalidFields,
    setInvalidFields,
  );

  return (
    <div className={styles.wrapper}>
      {formState && formState.operator && (
        <>
          {formState.operator === LogicalOperator.AND && (
            <p>Becomes {typeOfClause} when all conditions are met.</p>
          )}
          {formState.operator === LogicalOperator.OR && (
            <p>Becomes {typeOfClause} when any of the conditions are met.</p>
          )}
        </>
      )}
      <Select
        id={`task-logical-operator-${typeOfClause}`}
        name="operator"
        value={(formState && formState.operator) || ""}
        invalid={invalidFields.includes("operator")}
        invalidText="Select a valid operator (AND/OR)"
        labelText="Task Operator *"
        onChange={e => handleSelectChange(e, "operator")}
        size="sm"
      >
        <SelectItem text="Select an operator" value="" />
        <SelectItem key="and-operator" text="Match all conditions" value={LogicalOperator.AND} />
        <SelectItem key="or-operator" text="Match any condition" value={LogicalOperator.OR} />
      </Select>
      <div style={{ marginBottom: "10px" }} />

      {formState &&
        formState.conditions &&
        formState.conditions.map((condition, i) => (
          <TaskConditional
            key={`condition-${i}`}
            typeOfClause={typeOfClause}
            disabled // disable by default
            taskOptions={taskOptions}
            condition={condition}
            setCondition={updatedCondition => {
              if (updatedCondition === null) {
                setFormState({
                  ...formState,
                  conditions: removeTaskCondition(formState.conditions, i),
                });
                return;
              }
              setFormState({
                ...formState,
                conditions: updateTaskCondition(formState.conditions, i, updatedCondition),
              });
            }}
            setDisableModalSubmit={setDisableModalSubmit}
          />
        ))}

      {formState && (
        <TaskConditional
          typeOfClause={typeOfClause}
          taskOptions={taskOptions}
          setCondition={condition => {
            setFormState({
              ...formState,
              conditions: formState.conditions ? [...formState.conditions, condition] : [condition],
            });
          }}
          setDisableModalSubmit={setDisableModalSubmit}
        />
      )}
    </div>
  );
};

export default TaskClauseEditor;
